/**
 * @param {string} character
 * @returns {boolean}
 */
 export const isEnglishOnly = (character: string) => {
    let res = /^(?! )[.a-zA-Z\ \-]+$/.test(character);
    return res
}

/**
 * @param {string} character
 * @returns {boolean}
 */
 export const isEnglishAndNumberOnly = (character: string) => {
    let res = /^[a-zA-Z0-9]+$/.test(character);
    return res
}

/**
 * @param {string} character
 * @returns {boolean}
 */
 export const isNumberOnly = (character: string) => {
    let res = /^[0-9+]+$/.test(character);
    return res
}

/**
 * @param {string} email
 * @returns {boolean}
 */
 export const isEmail = (email: string) => {
    let res = /\S+@\S+\.\S+/.test(email);
    return res
}
